"use client";
import {
  Table as ChakraTable,
  TableContainer,
  Tbody,
  Thead,
  Th,
  Tr,
  Stack,
  Td,
  Text,
  Icon,
} from "@chakra-ui/react";
import { SectionDivider } from "app/components/shared/SectionDivider";
import { FaCheck, FaTimes } from "@onemind-services-llc/react-icons-ng/fa";
import {
  EVE_NG_COMPARE_TABLE_DATA,
  EVE_NG_COMPARE_TABLE_HEADERS,
} from "./components/constants";

const EveNgCompareTable = () => {
  const borderColor = "rgba(0, 0, 0, 0.24)";
  return (
    <Stack id="eve-ng-comparison-table" data-cy="section-comparison-table">
      <SectionDivider label={"EVE-NG Comparison"} />
      <TableContainer>
        <ChakraTable borderColor={borderColor} borderWidth="1px">
          <Thead>
            <Tr>
              {EVE_NG_COMPARE_TABLE_HEADERS.map((header, index) => {
                return (
                  <Th
                    borderBottomWidth="1px"
                    borderColor={borderColor}
                    key={index}
                    textAlign={header === "Features/Edition" ? "start" : "center"}
                    textTransform={"none"}
                    fontSize={"14px"}
                    wordBreak={"break-all"}
                  >
                    {header}
                  </Th>
                );
              })}
            </Tr>
          </Thead>
          <Tbody>
            {EVE_NG_COMPARE_TABLE_DATA.map((content, index) => {
              return (
                <Tr key={index}>
                  <Td minW={"200px"} whiteSpace={"normal"} wordBreak={"break-word"}>
                    <Text>{content.feature}</Text>
                  </Td>
                  <Td textAlign={"center"}>
                    {typeof content.community === "boolean" ? (
                      <RenderBoolean value={content.community} />
                    ) : (
                      <Text>{content.community}</Text>
                    )}
                  </Td>
                  <Td textAlign={"center"}>
                    {typeof content.professional === "boolean" ? (
                      <RenderBoolean value={content.professional} />
                    ) : (
                      <Text>{content.professional}</Text>
                    )}
                  </Td>
                  <Td textAlign={"center"}>
                    {typeof content.learning_center === "boolean" ? (
                      <RenderBoolean value={content.learning_center} />
                    ) : (
                      <Text>{content.learning_center}</Text>
                    )}
                  </Td>
                  <Td minW={"400px"} whiteSpace={"normal"} wordBreak={"break-word"}>
                    <Text>{content.desc}</Text>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </ChakraTable>
      </TableContainer>
    </Stack>
  );
};

export default EveNgCompareTable;

const RenderBoolean = ({ value }: { value: boolean }) => {
  return (
    <Icon
      as={value ? FaCheck : FaTimes}
      color={value ? "green.300" : "red.300"}
      fontSize={"18px"}
    />
  );
};
